import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ Import directo de la función

// 🎨 Colores institucionales
const COLOR_PRIMARY = [15, 76, 129]; // Azul CardioHard
const COLOR_LIGHT = [248, 250, 252]; // Gris clarito para fondo

export const exportarPDF = (titulo, columnas, filas, nombreArchivo = "reporte") => {
  const doc = new jsPDF();
  const fecha = new Date().toLocaleString("es-AR");

  // 1. Encabezado Azul
  doc.setFillColor(...COLOR_PRIMARY);
  doc.rect(0, 0, 210, 40, "F"); // Rectángulo azul arriba

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.text("CardioHard ANMAT", 14, 15);

  doc.setFontSize(16);
  doc.text(titulo, 14, 30);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Generado: ${fecha}`, 14, 36);

  // 2. Preparar headers y filas
  const headers = columnas.map(c => (typeof c === 'object' ? c.header : c));
  
  const bodyData = filas.map(fila => {
    if (Array.isArray(fila)) return fila;
    return headers.map(h => {
       const val = fila[h.toLowerCase()] || fila[h] || "";
       return typeof val === 'object' ? JSON.stringify(val) : val;
    });
  });

  // 3. ✅ Usar autoTable como función (NO como método de doc)
  autoTable(doc, {
    startY: 50,
    head: [headers],
    body: bodyData,
    theme: "striped",
    headStyles: { 
      fillColor: COLOR_PRIMARY, 
      textColor: 255,
      fontStyle: "bold"
    },
    alternateRowStyles: { fillColor: COLOR_LIGHT },
    margin: { left: 14, right: 14 },
    styles: { fontSize: 9, cellPadding: 3 }
  });

  // 4. Pie de página
  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(
      `Página ${i} de ${pageCount} · CardioHard ANMAT`, 
      14, 
      290
    );
  }

  // 5. Descargar
  doc.save(`${nombreArchivo}_${Date.now()}.pdf`);
};